import { Injectable } from '@angular/core';
import { Microservices } from '../../microservices';
import { MainService } from '../main/main.service';


@Injectable({
  providedIn: 'root'
})
export class MissingListByShipmentService {
  private list: Array<Missing> = [];
  private actions: {};
  private role: string = localStorage.getItem('role')
  constructor(
    private ms: MainService,
    private micro: Microservices) {
  }

  /**
   * @description We get a array of action to deleted and iterate the list to find and remove it
   * @param list Array of next actions
   * @param type Array of action to delete
   * @author 🔥
   */
  removeActionOfList(list: Missing[], action: Action[]) {
    list = list.filter((value) => !action.includes(value.type));
    return list
  }

  /**
   * @description Using the company's id we can check who is the Broker and who is the Carrier. We get a list of actions can do every role
   * and depend of who is the broker o the carrier we removed that actions of the list and return the rest.
   * @param shipment FTL Shipment Obj
   * @param agreement Agreement Document Obj
   * @param role Role
   * @author 🔥
   */
  getListMissing(shipment?: any, agreement?: any, role?: Role) {
    const { ms } = this;
    //TODO: Added documents step
    this.actions = {
      'new': [{
        label: 'Invitar',
        type: 'INVITE'
      },
      {
        label: 'A bordo',
        type: 'ONBOARD'
      }, {
        label: 'Add Origin & Destination Info',
        type: 'APPOINMENT',
      }],
      'open': [{
        label: 'Invitar',
        type: 'INVITE'
      },
      {
        label: 'A bordo',
        type: 'ONBOARD'
      }, {
        label: 'Add Origin & Destination Info',
        type: 'APPOINMENT',
      }, {
        label: 'Negotiate',
        type: 'BID'
      }],
      'awarded': [{
        label: 'Aprobar documentos',
        type: 'APPROVED'
      }, {
        label: 'Add Origin & Destination Info',
        type: 'APPOINMENT',
      }, {
        label:  'Firmar términos y condiciones',
        type: 'SIGN_CONF'
      }, {
        label: 'Add Driver',
        type: 'DRIVER',
      }]
    }

    let arr = (<Array<Missing>>this.actions[shipment._tradeRegistry.state]);
    let actToDelete: Action[] = [];
    if (role !== "carrier") {
      actToDelete.push('DRIVER', 'SIGN_CONF');
      if (shipment.bids && shipment.bids.bidder && shipment.bids.bidder === role) actToDelete.push('BID');
      if (shipment._booking.shipper.checklist.appointment.check) actToDelete.push('APPOINMENT');
      if (shipment._booking.shipper.checklist.docs.check) actToDelete.push('APPROVED');
      return this.removeActionOfList(arr, actToDelete);
    }

    if (role === "carrier") {
      actToDelete.push('INVITE', 'ONBOARD', 'APPROVED', 'APPOINMENT');
      if (shipment.bids && shipment.bids.bidder && shipment.bids.bidder === role) actToDelete.push('BID');
      if (agreement && agreement.accepted) actToDelete.push('SIGN_CONF');
      if (shipment._booking.carrier.checklist.attachDriver.check) actToDelete.push('DRIVER');
      return this.removeActionOfList(arr, actToDelete);
    }
  }
}

type Action = 'INVITE' | 'ONBOARD' | 'APPOINMENT' | 'DOCUMENTS' | 'BID' | 'APPROVED' | 'SIGN_CONF' | 'DRIVER';
export interface Missing {
  label?: string;
  action?: () => any | void;
  type?: Action;
  value?: string;
}
export enum Role {
  'shipper' = 'shipper',
  'broker' = 'broker',
  'carrier' = 'carrier'
}
